import * as channelRoutines from '../Containers/Channels/channelRoutines';
import * as dashboardRoutines from '../Containers/Dashboard/dashboardRoutines';
import * as eventRoutines from '../Containers/Events/eventRoutines';
import * as _ from 'lodash';
import { produce } from 'immer';
export default function reducer(
    state = {
        primary: {},
        secondary: {
            isChannelsEnabled: false,
            isPeerToPeerEnabled: false,
            isPeerToPeerVideoChatEnabled: false,
        },
    },
    action = {},
) {
    switch (action.type) {
        case eventRoutines.fetchActiveModules.SUCCESS:
            return produce(state, draft => {
                draft.primary = action.payload;
            });

        case eventRoutines.updateActiveModule.SUCCESS:
            const { moduleName, status } = action.payload;
            return {
                ...state,
                primary: {
                    ...state.primary,
                    [moduleName]: status,
                },
            };
        case eventRoutines.updatePeerToPeerModule.SUCCESS:
            return produce(state, draft => {
                draft.secondary.isPeerToPeerEnabled = action.payload.isEnabled;
            });
        case eventRoutines.updatePeerToPeerVideoChat.SUCCESS:
            return produce(state, draft => {
                draft.secondary.isPeerToPeerVideoChatEnabled = action.payload.isVideoChatEnabled;
            });
        case eventRoutines.updateChannelsModule.SUCCESS:
            return produce(state, draft => {
                draft.secondary.isChannelsEnabled = action.payload.isEnabled;
            });
        case channelRoutines.syncChannels.SUCCESS:
            return produce(state, draft => {
                draft.secondary.isChannelsEnabled =
                    action.payload && action.payload.isEnabled ? action.payload.isEnabled : false;
            });

        case dashboardRoutines.syncPeerToPeerStatus.SUCCESS:
            return produce(state, draft => {
                draft.secondary.isPeerToPeerEnabled = _.get(action, 'payload.isEnabled', false)
                draft.secondary.isPeerToPeerVideoChatEnabled = _.get(action, 'payload.isVideoChatEnabled', false)

            });

        default:
            return state;
    }
}
